import isNumber from 'lodash/isNumber';
import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
export const SkeletonWrapper = styled.div `
  ${({ width }) => width && `max-width: ${width}px`};
  ${({ isFullWidth }) => isFullWidth && 'width: 100%'};
  ${({ mtS }) => isNumber(mtS) && `margin-top: ${mtS}px`};
  ${({ mbS }) => isNumber(mbS) && `margin-bottom: ${mbS}px`};
  ${({ mlS }) => isNumber(mlS) && `margin-left: ${mlS}px`};
  ${({ mrS }) => isNumber(mrS) && `margin-right: ${mrS}px`};

  ${ADAPTIVE.minWidth.tablet} {
    ${({ mtM }) => isNumber(mtM) && `margin-top: ${mtM}px`};
    ${({ mbM }) => isNumber(mbM) && `margin-bottom: ${mbM}px`};
    ${({ mlM }) => isNumber(mlM) && `margin-left: ${mlM}px`};
    ${({ mrM }) => isNumber(mrM) && `margin-right: ${mrM}px`};
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${({ mtL }) => isNumber(mtL) && `margin-top: ${mtL}px`};
    ${({ mbL }) => isNumber(mbL) && `margin-bottom: ${mbL}px`};
    ${({ mlL }) => isNumber(mlL) && `margin-left: ${mlL}px`};
    ${({ mrL }) => isNumber(mrL) && `margin-right: ${mrL}px`};
  }
`;
